export default __webpack_public_path__ + "static/media/delivery-small-icon.219e5b90.svg";